// components/ImageHeader.js
import { useState, useEffect } from 'react'
import { getStorage, ref, getDownloadURL } from 'firebase/storage'
import { app } from '../firebase'
import './ImageHeader.css'

function ImageHeader ({ imageUrl, companyId }) {
  const [headerImageUrl, setHeaderImageUrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadImage = async () => {
      setLoading(true)
      setError(null)

      try {
        // If imageUrl is provided directly, use it
        if (imageUrl) {
          setHeaderImageUrl(imageUrl)
          setLoading(false)
          return
        }

        // Otherwise, try to load from Firebase Storage
        if (companyId) {
          const storage = getStorage(app)
          
          // Try common image formats
          const imageFormats = ['header.jpg', 'header.png', 'header.webp', 'header.jpeg']
          
          for (const format of imageFormats) {
            try {
              const storageRef = ref(storage, `company-headers/${companyId}/${format}`)
              const url = await getDownloadURL(storageRef)
              setHeaderImageUrl(url)
              setLoading(false)
              return
            } catch (err) {
              // Continue to next format if this one doesn't exist
              if (err.code !== 'storage/object-not-found') {
                throw err
              }
            }
          }

          // No image found in any format
          setHeaderImageUrl(null)
          setLoading(false)
        } else {
          setHeaderImageUrl(null)
          setLoading(false)
        }
      } catch (err) {
        console.error('Error loading header image:', err)
        setError(err.message)
        setHeaderImageUrl(null)
        setLoading(false)
      }
    }

    loadImage()
  }, [imageUrl, companyId])

  // Don't render anything if no image is available
  if (loading || !headerImageUrl) {
    return null
  }

  return (
    <div className='image-header-container'>
      <img
        src={headerImageUrl}
        alt='Header'
        className='image-header'
        onError={() => {
          setHeaderImageUrl(null)
          setError('Failed to load image')
        }}
      />
    </div>
  )
}

export default ImageHeader

